

let _ = require('../_.js');
let $ = jQuery;


_.Page_Lots = class Page_Lots {

    static init() {
        _.AuctionUI_Router.on_navigate(
            _.Page_Lots.on_navigate_match,
            _.Page_Lots.on_navigate_show,
            _.Page_Lots.on_navigate_hide
        );

        // Update view as data is updated
        _.AuctionUI_Data.on_data_update("auction.auction_items", _.Page_Lots.update_lots_data);

        // Hook clicking on lots to go to lot details
        _.on_ui_update_once(".ac-page-lots-lot", function () {
            $(this).click(function () {
                let item_id = $(this).data('cid');
                _.AuctionUI_Router.navigate_to("lots/" + item_id);
            })
        })
    }

    // Called when SPA hash based navigation happens, return true if handling dispatch
    static on_navigate_match(hash) {
        if (hash == "lots") {
            return true;
        } else {
            return false;
        }
    }

    // Called on successful dispatch
    // This should SHOW all elements related to this 'page'
    static async on_navigate_show(hash) {
        $(".component-auction-lots").show();

        await _.Page_Lots.update_lots_data(true);
    }

    // This should HIDE all elements related to this 'page'
    static on_navigate_hide() {
        $(".component-auction-lots").hide();
    }


    // Refreshes content in the lots modal.
    static async update_lots_data(force = false) {
        return;

        await _.mutex("AuctionUI_Page_Lots_UpdateData", async function () {
            let $page = $(".component-auction-lots");

            if (!$page.is(":visible") && !force) {
                return;
            }

            let auction = _.ac_state.auction;
            let auction_items = await auction.auction_items.fetch();

            let refresh_promises = [];
            let found_ids = [];

            let $container = $page.find(".ac-page-lots-grid");

            // Go through these in parallel
            auction_items.forEach(function (item) {
                refresh_promises.push((async function () {

                    found_ids.push(item.id);

                    let $component = $container.component(item.id);

                    if (item.lot_number) {
                        $component.find(".ac-page-lots-lot-number").text("#" + item.lot_number);
                    } else {
                        $component.find(".ac-page-lots-lot-number").html("&nbsp;");
                    }

                    $component.find(".ac-page-lots-lot-title").text(item.title);

                    $component.find(".ac-page-lots-lot-photo").divimg(await _.lib_items_get_featured_photo(item));

                    $component.find(".ac-page-lots-lot-short-description").text(item.brief_description);

                    $component.find(".ac-page-lots-lot-facts-acres").text(item.acres);

                    let $statusElement = $component.find(".ac-page-lots-lot-facts-status");

                    $statusElement.text(item.status_label);
                    if (!$statusElement.hasClass(item.status_badge)) {
                        $statusElement.attr('class', function (i, c) {
                            return c.replace(/(^|\s)badge-\S+/g, '');
                        });
                        $statusElement.addClass(item.status_badge_frontend);
                    }

                    let bidding_active = (item.status == App_Models_AuctionRound.STATUS_ACTIVE || item.status == App_Models_AuctionRound.STATUS_FINALIZING ||
                        item.status == App_Models_AuctionRound.STATUS_PAUSED || item.status == App_Models_AuctionRound.STATUS_ONCE || item.status == App_Models_AuctionRound.STATUS_TWICE);

                    let show_prices = bidding_active || item.status == App_Models_AuctionRound.STATUS_SOLD;

                    $component.find(".ac-page-lots-lot-facts-high-bid").text(show_prices ? _.currency(item.current_bid_amount) : "");

                    $component.find(".ac-page-lots-lot-facts-ask").text(bidding_active ? _.currency(item.ask) : "");

                    $component.find(".ac-page-lots-lot-facts-num-bids").text(await _.Lib_Auction_Bids.count_total_bids(item));

                })());
            });

            await Promise.all(refresh_promises);

            $container.remove_unlisted_components(found_ids);
        });
    }
}